<template>
    <div class="kgk-user-change-profile">
        <h2 v-if="!insideModal">
            Profil ändern
        </h2>
        <form @submit.prevent="performUpdate">
            <div class="kgk-form-row">
                Benutzername
                <div class="kgk-input-group">
                    <input type="text" required v-model="username" name="username" disabled>
                </div>
            </div>

            <div class="kgk-form-row">
                Vorname
                <div class="kgk-input-group">
                    <input type="text" required v-model="form.prename" name="prename">
                </div>
                <div v-if="showValidationErrors && !prenameRequiredValidation" class="kgk-form-validation-error-inline">Du musst einen Vornamen angeben.</div>
            </div>
            <div class="kgk-form-row">
                Nachname
                <div class="kgk-input-group">
                    <input type="text" required v-model="form.surname" name="surname">
                </div>
                <div v-if="showValidationErrors && !surnameRequiredValidation" class="kgk-form-validation-error-inline">Du musst einen Nachnamen angeben.</div>
            </div>
            <div class="kgk-form-row">
                Körpergröße
                <div class="kgk-input-group">
                    <input type="text" :required="heightIsRequired" v-model="form.height" style="width:50%;" name="height">
                    <div class="kgk-input-group-append">cm</div>
                </div>
                <div v-if="showValidationErrors && !heightRequiredValidation" class="kgk-form-validation-error-inline">Du musst deine Körpergröße in cm angeben.</div>
            </div>
            <div class="kgk-form-row">
                Schrittlänge
                <div class="kgk-input-group">
                    <input type="text" v-model="form.stride" style="width:50%;" name="stride">
                    <div class="kgk-input-group-append">cm</div>
                </div>
                <p><i style="font-size:80%">Du kannst deine Schrittlänge selbst eingeben oder mithilfe der Körpergröße und einer allgemeinen Formel ein Näherungsergebnis berechnen lassen.</i></p>
            </div>
            
            <div class="kgk-form-row">
                Firma

                <p><i>Kann in diesem Formular nicht geändert werden.</i></p>
                <!--<div class="kgk-input-group">
                    <input type="text" v-model="form.company" name="company">
                </div>-->
            </div>

            <!--div class="kgk-form-row">
                Geburtsdatum
                <div class="kgk-input-group">
                    <input type="text" required v-model="form.birthday" placeholder="dd.mm.yyyy" name="birthday">
                </div>
                <div v-if="showValidationErrors && !birthdayFormatValidation" class="kgk-form-validation-error-inline">Ungültiges Datum</div>
                <div v-if="showValidationErrors && !birtdayRequiredValidation" class="kgk-form-validation-error-inline">Du musst ein Geburtsdatum angeben.</div>
                <datetime
                        type="date"
                        format="cccc, dd.LL.yy"
                        value-zone="UTC+2"
                        zone="UTC+2"
                        v-model="form.birthday"
                        inputClass="form-control text-center"
                        auto
                        :phrases="{cancel: 'Abbrechen', ok: 'Übernehmen'}">
                </datetime>
            </div>-->

            <!--div class="kgk-form-row">
                Straße & Hausnummer
                <div class="kgk-input-group">
                    <input type="text" required v-model="form.street" name="street">
                    <input type="text" required v-model="form.streetnumber" style="width:20%;" name="streetnumber">
                </div>
                <div v-if="showValidationErrors && !streetRequiredValidation" class="kgk-form-validation-error-inline">Du musst eine Straße angeben.</div>
                <div v-if="showValidationErrors && !streetnumberRequiredValidation" class="kgk-form-validation-error-inline">Du musst eine Hausnummer angeben.</div>
            </div-->
            <div class="kgk-form-row">
                PLZ & Stadt
                <div class="kgk-input-group">
                    <input type="number" required v-model="form.zip" style="width:20%;" name="zip">
                    <input type="text" required v-model="form.city" name="city">
                </div>
                <div v-if="showValidationErrors && !zipRequiredValidation" class="kgk-form-validation-error-inline">Du musst eine Postleitzahl angeben.</div>
                <div v-if="showValidationErrors && !cityRequiredValidation" class="kgk-form-validation-error-inline">Du musst eine Stadt angeben.</div>
            </div>

            <div class="kgk-form-row kgk-form-row--wide" id="verify-age-jump">
                <label>
                    <input type="checkbox" v-model="form.verify_age" :disabled="this.user.verify_age">
                    Ich bestätige, dass ich zum Zeitpunkt der Registrierung mindestens 16 Jahre alt bin.
                </label>
            </div>

            <div class="kgk-form-row kgk-form-row--wide" style="max-width: none;">
                <label>
                    <input type="checkbox" v-model="form.consent_campaign" disabled>
                    Ich habe die Datenschutzerklärung zur Kenntnis genommen und stimme der Verwendung meiner Daten gemäß Datenschutzerklärung zu.
                </label>
                <div v-if="showValidationErrors && !consentCampaignValidation" class="kgk-form-validation-error-inline">Sie müssen der Datenverarbeitung zustimmen.</div>
            </div>

            <div class="kgk-form-row kgk-form-row--wide">
                <label>
                    <input type="checkbox" v-model="form.consent_afterwards">
                    Ich stimme zu, zukünftig per E-Mail über Neuigkeiten und Aktionen der Krebsgesellschaft NRW informiert zu werden.
                </label>
            </div>

        </form>
    </div>
</template>

<script>
    import user from '../../api/user';
    //import router from '../../router';

    const dateRegex = /^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/;
    //const usernameRegex = /[-_@!.a-zA-Z0-9äÄöÖüÜß]/g;

    export default {
        name: 'UserChangeProfileForm',
        components: {

        },
        props: {
            insideModal: {
                type: Boolean,
                //required: true,
                default: false,
            },
            modalSaveTrigger: {
                type: Object,
                required: false
            },
            user: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                loading: false,
                form: {
                    prename: '',
                    surname: '',
                    //company: '',
                    companyData: null,
                    //birthday: '',
                    //street: '',
                    //streetnumber: '',
                    zip: '',
                    city: '',
                    height: '',
                    stride: '',
                    consent_campaign: false,
                    consent_afterwards: false,
                    verify_age: false,
                },
                username: '',
                showValidationErrors: false,
                error: '',
            }
        },
        computed: {
            prenameRequiredValidation() {
                return this.form.prename.trim().length > 0;
            },
            surnameRequiredValidation() {
                return this.form.surname.trim().length > 0 ;
            },
            // birtdayRequiredValidation() {
            //     return this.form.birthday.trim().length > 0;
            // },
            // birthdayFormatValidation() {
            //     if( this.form.birthday.trim().length == 0 ) {
            //         return true;
            //     }

            //     return dateRegex.test(this.form.birthday);
            // },
            // streetRequiredValidation() {
            //     return this.form.street.trim().length > 0;
            // },
            // streetnumberRequiredValidation() {
            //     return this.form.streetnumber.trim().length > 0;
            // },
            heightRequiredValidation() {
                if(!this.heightIsRequired){
                    return true;
                }
            
                if(this.form.height.trim().length > 0 && this.form.height.trim() > 100 && typeof this.form.height !== 'undefined')
                {
                    this.checkStride();

                    return true;
                }else{
                    return false;
                }
            },
            heightIsRequired() {
                if(this.user.run_type == 1){
                    return true;
                }else{
                    return false;
                }
            },
            strideRequiredValidation() {
                if(typeof this.form.stride !== 'undefined' || this.form.stride > 0)
                {
                    return true;
                }
                else
                {
                    this.checkStride();
                    return true;
                }
            },
            zipRequiredValidation() {
                return this.form.zip.trim().length > 0;
            },
            cityRequiredValidation() {
                return this.form.city.trim().length > 0;
            },
            consentCampaignValidation() {
                return !!this.form.consent_campaign;
            },
            verifyAgeValidation() {
                return !!this.form.verify_age;
            },
        },
        methods: {
            checkStride(){
                    this.form.stride = this.form.height * 0.415;
            },
            performUpdate(/*calledFromModal*/) {
                //calledFromModal = calledFromModal || false;

                if( this.loading ) {
                    return;
                }

                this.showValidationErrors = true;

                // || !this.birthdayFormatValidation
                if( !this.prenameRequiredValidation
                    || !this.surnameRequiredValidation
                    // || !this.birtdayRequiredValidation
                    // || !this.streetRequiredValidation
                    // || !this.streetnumberRequiredValidation
                    || !this.strideRequiredValidation
                    || !this.heightRequiredValidation
                    || !this.zipRequiredValidation
                    || !this.consentCampaignValidation
                    || !this.verifyAgeValidation ) {
                    this.$notify({
                        type: 'warn',
                        title: 'Eingaben fehlerhaft.',
                        text: 'Bitte korrigiere deine Formulareingaben.'
                    });

                    return;
                }

                this.loading = true;

                this.$emit('loadingStarted');

                user.update(
                    this,
                    this.form,
                    () => {
                        //console.log(data);

                        this.$notify({
                            type: 'success',
                            title: 'Profil gespeichert',
                            text: 'Dein Profil wurde erfolgreich gespeichert.'
                        });

                        this.$emit('changed');

                        //router.push('/login');
                    },
                    e => {
                        //console.error(e.response.status);

                        if( e.response.status == 400 || typeof e.response.data.message !== 'undefined' ) {
                            /*if( typeof e.response.data.field !== 'undefined' ) {
                                // maybe highlight error field
                            }*/

                            this.$notify({
                                type: 'error',
                                title: 'Fehler',
                                text: e.response.data.message
                            });
                            return;
                        }

                        this.$notify({
                            type: 'error',
                            title: 'Es ist ein unbekannter Fehler aufgetreten.',
                            text: 'Bitte versuch es noch einmal.'
                        });
                    },
                    () => {
                        this.loading = false;
                        this.$emit('loadingEnded');
                    }
                );
            },

        },
        watch: {
            'modalSaveTrigger.trigger'() {
                this.performUpdate();
            },
            'form.height'(value){
                this.form.height = value;
                this.checkStride();
            },
        },
        mounted() {
            if( !this.user ) {
                return;
            }

            this.username = this.user.username;
            this.form.prename = this.user.prename;
            this.form.surname = this.user.surname;
            this.form.company = this.user.company;
            this.form.companyData = this.user.companyData;
            //this.form.birthday = this.convertDateReadableLong(this.user.birthday);
            // this.form.street = this.user.street;
            // this.form.streetnumber = this.user.streetnumber;
            this.form.height = typeof this.user.height !== 'undefined' ? this.user.height : 0;
            this.form.stride = typeof this.user.stride !== 'undefined' ? this.user.stride : 0;
            this.form.zip = this.user.zip;
            this.form.city = this.user.city;
            this.form.consent_campaign = this.user.consent_campaign;
            this.form.consent_afterwards = this.user.consent_afterwards;
            this.form.verify_age = this.user.verify_age;


            if(this.$route.query.jumpto == 'vaj'&&!this.user.verify_age){
                const verifyAgeCheckbox = document.getElementById('verify-age-jump');
                //document.getElementById('verify-age-jump').style.backgroundColor = 'red' 
                verifyAgeCheckbox.scrollIntoView({behavior: 'smooth'});
                verifyAgeCheckbox.style.backgroundColor = 'rgb(221, 0, 0)';
            }
        }
    }
</script>

